import { Grid } from "@mui/material";
import React from "react";
import {
  ProjectsMainContainer,
  HeaderWrap,
  CardsMainContainer,
  ProjectImg,
  IconLink,
  ProjectsHeader,
  DetailsHeaderWrap,
  DetailsSummaryContainer,
  ProjectDetailsButton,
} from "./StyledProjectSection";
import { projectsData } from "./projectsData";

function ProjectsSection() {
  return (
    <ProjectsMainContainer
      container
      id="projects"
      justifyContent="center"
      alignItems="center"
    >
      <HeaderWrap container>
        <ProjectsHeader> My Latest Projects</ProjectsHeader>
      </HeaderWrap>
      <CardsMainContainer container>
        {projectsData.map((project) => (
          <Grid key={project.id} container item lg={4} xs={6}>
            <ProjectImg
              container
              item
              key={project.id}
              justifyContent="center"
              alignItems="center"
              sx={{
                backgroundImage: `url(${project.img})`,
                backgroundSize: "cover",
              }}
            >
              <Grid
                container
                item
                justifyContent="center"
                alignItems="center"
                direction="column"
              >
                <DetailsHeaderWrap item>{project.title}</DetailsHeaderWrap>
                <DetailsSummaryContainer item>
                  {project.description}
                </DetailsSummaryContainer>
                <Grid
                  item
                  xs={12}
                  md={6}
                  justifyContent="center"
                  alignItems="center"
                >
                  <IconLink href={project.url}>
                    <ProjectDetailsButton item>
                      Check it out!
                    </ProjectDetailsButton>
                  </IconLink>
                </Grid>
              </Grid>
            </ProjectImg>
          </Grid>
        ))}
      </CardsMainContainer>
    </ProjectsMainContainer>
  );
}

export default ProjectsSection;
